import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import style from "./AppoinmentCreation.module.css";
import DayPicker, { DateUtils } from "react-day-picker";
import "react-day-picker/lib/style.css";
import history from "../../utils/history";
import { Formik, Field, Form, ErrorMessage } from "formik";
// var DateTimeField = require('react-bootstrap-datetimepicker');
// var DateTimeField = require('react-bootstrap-datetimepicker').DateTimeField;
// import DateTimeField from 'react-bootstrap-datetimepicker'
import TimeField from "react-simple-timefield";
import api from "../../utils/Api";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import moment from "moment";
import { connect } from "react-redux";
import { fetchAppointmentDropdown } from "../../redux";
import { checkIfPermitted, Permissions } from "../../services/RolePermissionService";
import { Select } from "antd";
import { validateEmail, validateNumber, validateName, checkValidData, getFormattedBookedTime, isValEmpty, validateAlphaNumeric } from "../../utils/CommonUtil";
import { isEmpty } from "lodash";
import { AppointmentNotesSection } from "./AppointmentNotesSection";
const { Option } = Select;
export class AppoinmentCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPageTitle: "Create Appointment",
      assoRelatedParty: "",
      assoRelatedPartyName: "",
      reqProfessional: "",
      reqProfessionalName: "",
      authorNumber: "",
      appoType: "",
      user_type:"existing",
      new_user_first_name:"",
      new_user_last_name:"",
      new_user_passport_number:"",
      new_user_number:"",
      intialAppStatus: null,
      appStatus: null,
      paymentType: "2",
      room: "",
      appoReason: "",
      billing_policy_configuration_id: "",
      rule_type_id: "",
      notes: "",
      setRemind: "",
      showDatetime: true,
      name: "",
      PhysicalAddress: "",
      refnumber: "",
      fileNumber: "",
      phoneNumber: "",
      emailId: "",
      doctorName: "",
      selectedDays: [],
      isOpen: false,
      selectedDateTime: [],
      selectedtime: "00:00",
      associatedRelatedParty: [],
      requestedProfessional: [],
      appointmentStatus: [],
      appointmentTypeDetails: [],
      appointmentReason: [],
      roomDetails: [],
      roomOptions: [],
      doctorBookedDateTime: [],
      doctorUpadteBookedDateTime: [],
      appointment_id: "",
      conductappointment_id: "",
      isLoading: false,
      successMessage: "",
      errorMessage: "",
      error: "",
      disabledDays: [],
      appointmentReasonLabel: "",
      doctorNameLabel: "",
      isEditLoading: false,
      reference_id: "",
      appomtReasonid: "",
      systemRole:
        (localStorage.getItem("USER_INFO") &&
          JSON.parse(localStorage.getItem("USER_INFO")).systemRole) ||
        "",
      attachedDocuments: [],
      selectedEndtime: "00:00",
      calendarErrorMessage: "",
      isCaseFileDownloading: false,
      isPatientFile: false,
      appointmentDropdownData: [],
      isReschedule: false,
      setRemindOneDay: [
        { id: 1, label: "1 hour before" },
        { id: 2, label: "2 hours before" },
        { id: 3, label: "3 hours before" },
        { id: 4, label: "4 hours before" },
        { id: 5, label: "1 day before" },
      ],
      isScreenLoaded: false,
      showErrors: {},
      isFormValid: true,
      invoice_id: "",
      estimate_invoice_id: "",
      invoice_list_type: "",
      mediswitch_transaction_id: "",
      practice_logo: "",
      patientDetail: {},
      practitionerDetail: {}
    };
  }

  componentDidMount = async() => {
    document.title = 'Manage Appointment - TechToMedix';
    let appointment_id = "";
    // fetch initial dropdown data
    // this.appointmentGetData();
    await this.props.fetchAppointmentDropdown();

    if (this.props.match.params.id) {
      this.setState({
        isEditMode: true,
        isEditLoading: true,
        isPageTitle: "Manage Appointment",
        appointment_id: this.props.match.params.id
      });
      appointment_id = this.props.match.params.id;

      // Fetching data for edit
      setTimeout(() => {
        this.getAppointmentEdit(appointment_id);
      }, 400);
    }else{
      this.setState({
        associatedRelatedParty: this.props.appointmentDropdownData
          .appointmentDropdown.associatedRelatedParty,
        requestedProfessional: this.props.appointmentDropdownData
          .appointmentDropdown.requestedProfessional,
        appointmentTypeDropdown: this.props.appointmentDropdownData
          .appointmentDropdown.appointmentTypeDropdown,
        roomDetails: this.props.appointmentDropdownData.appointmentDropdown
          .room,
          roomOptions: this.props.appointmentDropdownData.appointmentDropdown
          .room,
        appointmentReason: this.props.appointmentDropdownData
          .appointmentDropdown.appointmentReason,
        appointmentStatus: this.props.appointmentDropdownData
          .appointmentDropdown.appointmentStatus,
        isEditLoading: false,
      });
      setTimeout(() => {
        this.setState({
          isScreenLoaded: true,
        });
      }, 500);
    }
    // if(!this.props.appointmentDropdownData.loading){
    //}
  };

  componentDidUpdate(prevProps, prevState) {
    // if (!this.props.match.params.id) {
    //   this.resetForm();
    // }
    // if (
    //   prevProps.appointmentDropdownData != this.props.appointmentDropdownData
    // ) {
    //   this.setState({
    //     associatedRelatedParty: this.props.appointmentDropdownData
    //       .appointmentDropdown.associatedRelatedParty,
    //     requestedProfessional: this.props.appointmentDropdownData
    //       .appointmentDropdown.requestedProfessional,
    //     appointmentTypeDropdown: this.props.appointmentDropdownData
    //       .appointmentDropdown.appointmentTypeDropdown,
    //     roomDetails: this.props.appointmentDropdownData.appointmentDropdown
    //       .room,
    //       roomOptions: this.props.appointmentDropdownData.appointmentDropdown
    //       .room,
    //     appointmentReason: this.props.appointmentDropdownData
    //       .appointmentDropdown.appointmentReason,
    //     appointmentStatus: this.props.appointmentDropdownData
    //       .appointmentDropdown.appointmentStatus,
    //     isEditLoading: false,
    //   });
    // }

    if (prevProps.match.params.id !== this.props.match.params.id) {
    //  console.log("etstststtss");
      this.setState({
        isEditMode: false,
        assoRelatedParty: "",
        reqProfessional: "",
        authorNumber: "",
        appoType: "",
        appStatus: null,
        intialAppStatus: null,
        room: "",
        appoReason: "",
        billing_policy_configuration_id: "",
        billing_policy_value: "",
        rule_type_id: "",
        notes: "",
        setRemind: "",
        selectedDateTime: [],
        selectedTime: "",
        isPageTitle: "Appointment Creation",
        paymentType: "2",
        isAppointmentConducted: false,

        assoRelatedPartyName: "",
        reqProfessionalName: "",
        user_type:"existing",
        new_user_first_name:"",
        new_user_last_name:"",
        new_user_passport_number:"",
        new_user_number:"",
        showDatetime: true,
        name: "",
        PhysicalAddress: "",
        refnumber: "",
        fileNumber: "",
        phoneNumber: "",
        emailId: "",
        passport_number: "",
        doctorName: "",
        selectedDays: [],
        isOpen: false,
        selectedtime: "00:00",
        doctorBookedDateTime: [],
        doctorUpadteBookedDateTime: [],
        appointment_id: "",
        conductappointment_id: "",
        isLoading: false,
        successMessage: "",
        errorMessage: "",
        successMsg: "",
        errorMsg: "",
        error: "",
        disabledDays: [],
        appointmentReasonLabel: "",
        doctorNameLabel: "",
        isEditLoading: false,
        reference_id: "",
        appomtReasonid: "",
        attachedDocuments: [],
        selectedEndtime: "00:00",
        calendarErrorMessage: "",
        isCaseFileDownloading: false,
        isPatientFile: false,
        isReschedule: false,
        showErrors: {},
        isFormValid: true,
        invoice_id: "",
        estimate_invoice_id: "",
        isProfileCompleted: 0,
        practice_logo:"",
        patientDetail: {},
        practitionerDetail: {}
        
      });

      
    }
  }

  // appointmentGetData = async () => {
  //   const headers = {
  //     Authorization:
  //       "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  //   };
  //   try {
  //     const response = await api.get("appointment/initialData/fetch", {
  //       headers: headers,
  //     });
  //     console.log("+++++++++++++++++ appointmnet data", response);
  //     this.setState(
  //       {
  //         associatedRelatedParty: response.data.data.associatedRelatedParty,
  //         requestedProfessional: response.data.data.requestedProfessional,
  //         appointmentTypeDropdown: response.data.data.appointmentTypeDropdown,
  //         roomDetails: response.data.data.room,
  //         appointmentReason: response.data.data.appointmentReason,
  //         appointmentStatus: response.data.data.appointmentStatus,
  //         isEditLoading: false,
  //       },
  //       () => {
  //         this.getPreAppData();
  //       }
  //     );
  //   } catch (error) {
  //     console.log("Error in block time fetch data", error);
  //     this.setState({
  //       isEditLoading: false,
  //     });
  //   }
  // };

  getAppointmentEdit(appointment_id) {
    console.log("getAppointmentEdit:::", appointment_id);
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    api
      .get("appointment/" + appointment_id, {
        headers: headers,
      })
      .then((response) => {
        let appointmentEditResponse = response.data.data[0];
        // console.log(
        //   "Get response for appoinmt edit details ******** ",
        //   appointmentEditResponse
        // );

        // Fetching doctor name label
        let doctorId = appointmentEditResponse.requested_related_party_id;
        const dropdwnData = this.props.appointmentDropdownData && 
    this.props.appointmentDropdownData.appointmentDropdown ;
        let doctorPair = dropdwnData && dropdwnData.requestedProfessional.find(
          (element, index) => (
            element.related_party_id == doctorId
          )
        );

        const reasonLabel = dropdwnData && dropdwnData.appointmentReason.find((element) => {
          return (
            element.lk_appointment_reason_id ==
            appointmentEditResponse.lk_appointment_reason_id
          );
        });
       // console.log("reasonLabel", reasonLabel);

        this.setState(
          {
            assoRelatedParty:
              appointmentEditResponse.associated_related_party_id,
            reqProfessional: appointmentEditResponse.requested_related_party_id,
            authorNumber: appointmentEditResponse.authorization_number,
            appoType: appointmentEditResponse.lk_appointment_type,
            room: appointmentEditResponse.room_id,
            appoReason: appointmentEditResponse.lk_appointment_reason_id,
            billing_policy_configuration_id: appointmentEditResponse.billing_policy_configuration_id,
            billing_policy_value: appointmentEditResponse.billing_policy_value,
            rule_type_id: appointmentEditResponse.rule_type_id,
            appomtReasonid: appointmentEditResponse.lk_appointment_reason_id,
            appointmentReasonLabel: reasonLabel.appointment_reason || "",
            notes: appointmentEditResponse.notes,
            appStatus: appointmentEditResponse.lk_appointment_status_id,
            intialAppStatus: appointmentEditResponse.lk_appointment_status_id,
             doctorNameLabel: doctorPair.name,
            selectedDateTime: JSON.parse(
              appointmentEditResponse.appointment_date
            ),
            setRemind: appointmentEditResponse.lk_reminder_id,
            reference_id: appointmentEditResponse.reference_id,
            name: appointmentEditResponse.name,
            PhysicalAddress: appointmentEditResponse.physical_address,
            refnumber: appointmentEditResponse.reference_id,
            fileNumber: appointmentEditResponse.file_number,
            phoneNumber: appointmentEditResponse.contact_number,
            emailId: appointmentEditResponse.email,
            passport_number: appointmentEditResponse.passport_number,
            doctorUpadteBookedDateTime: JSON.parse(
              appointmentEditResponse.appointment_date
            ),
           // paymentType: appointmentEditResponse.payment_type,
            isAppointmentConducted:
              appointmentEditResponse.lk_appointment_status_id == 12,
            conductappointment_id:
              appointmentEditResponse.conductappointment_id,
            attachedDocuments: appointmentEditResponse.conductAppointmentNotes,
            isPatientFile: appointmentEditResponse.isPatientFile,
            invoice_id: appointmentEditResponse.invoice_id, 
            estimate_invoice_id: appointmentEditResponse.estimate_invoice_id,
            invoice_list_type: appointmentEditResponse.invoice_list_type,
            mediswitch_transaction_id: appointmentEditResponse.mediswitch_transaction_id,
            isProfileCompleted: appointmentEditResponse.isProfileCompleted === 1 ? 1 : 0,
            practice_logo: appointmentEditResponse.practice_logo ? appointmentEditResponse.practice_logo : "",
            patientDetail: appointmentEditResponse.patientDetail ? appointmentEditResponse.patientDetail : {},
            practitionerDetail: appointmentEditResponse.practitionerDetail ? appointmentEditResponse.practitionerDetail : {},
            isScreenLoaded: true
          },
          () => {
            // console.log(
            //   "isAppointmentConducted",
            //   this.state.isAppointmentConducted
            // );
            this.getPreAppData();
            this.getBlockTimePreData();
            this.setRemindTime();
          }
        );
      })
      .catch((error) => {
        // this.setState({
        //   loadingState: false,
        // });
        if (error.response) {
          console.log("Error", error);
        }
      });

    // Fetching appointment reason lable
    // setTimeout(() => {
    //   this.getAppoReasonLabel();
    // }, 500);
  }

  // Set remind me function
  setRemindTime = () => {
   // console.log("Selected date and time: ", this.state.selectedDateTime);
    if (this.state.selectedDateTime.length === 1) {
      const dateTime = new Date(this.state.selectedDateTime[0].bdate);
      dateTime.setHours(this.state.selectedDateTime[0].start.split(":")[0]);
      dateTime.setMinutes(this.state.selectedDateTime[0].start.split(":")[0]);
      let timeDiff = moment(dateTime).diff(moment(), "hours");
     // console.log("************ timeDiff", timeDiff);
      this.setState({
        setRemindOneDay: "",
      });
      if (timeDiff === 1) {
        this.setState({
          setRemindOneDay: [{ id: 1, label: "1 hour before" }],
        });
      } else if (timeDiff === 2) {
        this.setState({
          setRemindOneDay: [
            { id: 1, label: "1 hour before" },
            { id: 2, label: "2 hours before" },
          ],
        });
      } else if (timeDiff === 3) {
        this.setState({
          setRemindOneDay: [
            { id: 1, label: "1 hour before" },
            { id: 2, label: "2 hours before" },
            { id: 3, label: "3 hours before" },
          ],
        });
      } else if (timeDiff >= 4 && timeDiff < 24) {
        this.setState({
          setRemindOneDay: [
            { id: 1, label: "1 hour before" },
            { id: 2, label: "2 hours before" },
            { id: 3, label: "3 hours before" },
            { id: 4, label: "4 hours before" },
          ],
        });
      } else if (timeDiff >= 24) {
        this.setState({
          setRemindOneDay: [
            { id: 1, label: "1 hour before" },
            { id: 2, label: "2 hours before" },
            { id: 3, label: "3 hours before" },
            { id: 4, label: "4 hours before" },
            { id: 5, label: "1 day before" },
          ],
        });
      } else {
        // this.setState({
        //   setRemindOneDay: [
        //     "1 hour before",
        //     "2 hours before",
        //     "3 hours before",
        //     "4 hours before",
        //     "1 day before",
        //   ],
        // });
        const setRemindArr = [
          { id: 1, label: "1 hour before" },
          { id: 2, label: "2 hours before" },
          { id: 3, label: "3 hours before" },
          { id: 4, label: "4 hours before" },
          { id: 5, label: "1 day before" },
        ];
        const setRemindOneDayData = setRemindArr.filter((element, index) => {
          return index + 1 === this.state.setRemind;
        });
        // console.log(
        //   "######+++++++++++++++ setRemindOneDayData",
        //   setRemindOneDayData
        // );
        this.setState({
          setRemindOneDay: setRemindOneDayData,
          setRemind: this.state.setRemind,
        });
      }
    }
  };

  getAppoReasonLabel = () => {
    const dropdwnData = this.props.appointmentDropdownData && 
      this.props.appointmentDropdownData.appointmentDropdown ;
    let appointmentReasonpair = dropdwnData && dropdwnData.appointmentReason.find(
      (element, index) => {
        return element.lk_appointment_reason_id === this.state.appomtReasonid;
      }
    );
    if (appointmentReasonpair) {
      this.setState({
        appointmentReasonLabel: appointmentReasonpair.appointment_reason,
      });
    }
  };

  handleInputChange = (event) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState(
      {
        [name]: val,
      },()=>{
        // if (name === "room") {
        // this.getBlockTimePreData();
        // }
      });
      // if(name === "room"){
      //   this.setState({
      //     doctorBookedDateTime: [],
      //     selectedDateTime: [],
      //   })
      // }

      if(name === "billing_policy_configuration_id"){
        const dropdwnData = this.props.appointmentDropdownData && 
        this.props.appointmentDropdownData.appointmentDropdown ;
        const billingPolicy = dropdwnData && dropdwnData.billingPolicyConfiguration &&
         dropdwnData.billingPolicyConfiguration.find((element, index) => (
        element.billing_policy_configuration_id === Number(val)
      ));
        this.setState({
          billing_policy_value: billingPolicy && billingPolicy.percentage ? billingPolicy.percentage : 0,
        })
      }
      
      if (name === "appoReason") {
        let appointmentReasonLabel =
          event.target.options[event.target.selectedIndex].text;

        this.setState({
          appointmentReasonLabel: appointmentReasonLabel,
        });
      }

      
    if (name === "new_user_passport_number") {
      let result = validateAlphaNumeric(val);
      this.validateFormFields(result, name, "Only alphanumeric values allowed!");
    }
        
    if (name === "new_user_number") {
      let result = validateNumber(val);
      this.validateFormFields(result, name, "Only numbers are allowed!");
    }
    if (name === "new_user_first_name") {
      let result = validateName(val);
      this.validateFormFields(result, name, "Please enter valid first name!");
    }
    
    if (name === "new_user_last_name") {
      let result = validateName(val);
      this.validateFormFields(result, name, "Please enter valid last name!");
    }
    //console.log("showError", this.state.showErrors);
  };



  validateFormFields = (result, name, message) => {
    if(!result){
      this.setState({
        showErrors: {
          ...this.state.showErrors,
          [name]: message
        },
        isFormValid: false
      })
    }else{
      let showErrors = {...this.state.showErrors};
      delete showErrors[name];
      this.setState({
        showErrors: showErrors,
        isFormValid: true
      })
    }
  }

  handleInputSelChange = (val, name) => {
    // const val = event.target.value;
    // const name = event.target.name;

    if(name === "reqProfessional"){
      const dropdwnData = this.props.appointmentDropdownData && 
      this.props.appointmentDropdownData.appointmentDropdown ;
      let reqProf =  dropdwnData && dropdwnData.requestedProfessional &&
      dropdwnData.requestedProfessional.find((element) => {
            return element.related_party_id === parseInt(val);
          });
      //console.log("reqProfRoom", reqProfRoom);
      this.setState({
        doctorBookedDateTime: [],
        selectedDateTime: [],
        room: (reqProf && reqProf.room_id) ? reqProf.room_id:"",
        doctorName:(reqProf && reqProf.name) ? reqProf.name : "",
      })
      
    }

    if (name === "assoRelatedParty") {
      const dropdwnData = this.props.appointmentDropdownData && 
      this.props.appointmentDropdownData.appointmentDropdown ;
      let assoc =  dropdwnData && dropdwnData.associatedRelatedParty &&
      dropdwnData.associatedRelatedParty.find((element) => {
            return element.related_party_id === parseInt(val);
          });
      let text = assoc && assoc.name ? assoc.name : "";
      this.setState({
        assoRelatedPartyName: text,
      });
    }

    this.setState(
      {
        [name]: val,
      },
      () => {
        this.getPreAppData();
        if (name === "reqProfessional") {
          this.getBlockTimePreData();
        }
      }
    );
    
  
  };

  getPreAppData = () => {
    // getting appoinment type data
    let appointmentDropdownData =
      this.state.appointmentTypeDropdown &&
      this.state.appointmentTypeDropdown.find((element) => {
        return (
          element.associated_related_party_id == this.state.assoRelatedParty &&
          element.requested_related_party_id == this.state.reqProfessional
        );
      });

    this.setState({
      appointmentTypeDetails: appointmentDropdownData
        ? appointmentDropdownData.appointmentType
        : this.state.appointmentTypeDropdown &&
          this.state.appointmentTypeDropdown[0].appointmentType,
    });
   // this.getRoomData();
  };

  // getRoomData = () => {
  //   // getting room data
  //   console.log("++++++++++++ Room options 1", this.state.roomDetails);
  //   let roomDropdownData =
  //     this.state.roomDetails &&
  //     this.state.roomDetails.filter((element) => {
  //       return element.requested_related_party_id == this.state.reqProfessional;
  //     });
  //   console.log("++++++++++++ Room options 2", roomDropdownData);

  //   this.setState({
  //     roomOptions: roomDropdownData,
  //   });
  // };

  // Getting block time data
  getBlockTimePreData = () => {
    if (this.state.reqProfessional !== "") {
      // console.log(
      //   "this.state.requestedProfessional",
      //   this.state.requestedProfessional
      // );
      const dropdwnData = this.props.appointmentDropdownData && 
      this.props.appointmentDropdownData.appointmentDropdown ;
      let blockedDateTime = dropdwnData && dropdwnData.requestedProfessional.find((element) => (
        element.related_party_id == this.state.reqProfessional
      ));
     // console.log("blockedDateTime", blockedDateTime);

      const blockappointmentTimeData =
        blockedDateTime && blockedDateTime.blockappointment;
      let blockedTime =
        blockappointmentTimeData &&
        blockappointmentTimeData.find((element) => {
          return (
            element.requested_related_party_id == this.state.reqProfessional
          );
        });

      //console.log("blockedTime", blockedTime);
      if (blockedTime) {
        const finalData = JSON.parse(blockedTime.blocked_datetime);
        const selectDateTimeArray =
          finalData &&
          finalData.filter(function (item) {
            // return !moment(item.bdate).isBefore(Date.now(), 'day');
            const dateTime = new Date(item.bdate);
            dateTime.setHours(item.start.split(":")[0]);
            dateTime.setMinutes(item.start.split(":")[1]);
            return (
              !moment(dateTime).isBefore(Date.now(), "day") &&
              !moment(dateTime).isBefore(Date.now(), "hour") &&
              !moment(dateTime).isBefore(Date.now(), "minute")
            );
          });
        this.setState(
          {
            doctorBookedDateTime: selectDateTimeArray,
          },
          () => {
            //disabledDays
            const disableDates = this.disableCalendar();
            this.setState({ disabledDays: disableDates });
          }
        );
      } else {
        // this.setState({
        //   selectedDateTime: [],
        // });
      }
    }
  };

  handleChooseCalendar = (event) => {
    //console.log("test");
    this.setState({ showDatetime: true });
  };

  handlerTimeChange = (event, value) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
  };

  handleDayClick = (day, modifiers = {}) => {
    if (modifiers.disabled) {
      return;
    }

    const { selectedDays } = this.state;
    if (modifiers.selected) {
      const selectedIndex = selectedDays.findIndex((selectedDay) =>
        DateUtils.isSameDay(selectedDay, day)
      );
      selectedDays.splice(selectedIndex, 1);
    } else {
      selectedDays.push(day);
    }
   // console.log("selectedDays", selectedDays);
    this.setState({ selectedDays });
   // console.log(this.state.selectedDays[0]);
  };

  toggle = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
      calendarErrorMessage: "",
    }));
  };

  save = () => {
    const selectedDateTime = this.state.selectedDateTime;
    const selectedTime = this.state.selectedtime;
    const selectedEndTime = this.state.selectedEndtime;

    if( this.state.selectedDays.length === 0){
      this.setState({
        calendarErrorMessage: "Please select a date to proceed!",
      });
      return false;
    }

    //checking if selected date and time is of future or not.
    let startTimeInString = selectedTime.replace(":","");
    let endTimeInString = selectedEndTime.replace(":","");
    let currentTimeInString = new Date().toLocaleTimeString('en-US', { hour12: false, 
      hour: "numeric", 
      minute: "numeric"})
    let date = new Date();
    currentTimeInString = currentTimeInString.replace(":","");
    // let dateError =  this.state.selectedDays.find((item, index)=>
    // (item.toLocaleDateString() === date.toLocaleDateString()) && 
    // ((parseInt(startTimeInString) < parseInt(currentTimeInString)) ||
    // (parseInt(endTimeInString) < parseInt(currentTimeInString)))
    // )
    // if(dateError){
    //   this.setState({
    //     calendarErrorMessage: "Please select time slots of future!",
    //   });
    //   return false;
    // }
    if(selectedDateTime && selectedDateTime.length > 0 ){
     let error = selectedDateTime.find((elem)=>{
        let dateError =  this.state.selectedDays.findIndex((item)=>{
          let start = elem.start.replace(":","");
          let end = elem.end.replace(":","");
        return (item.toLocaleDateString() === new Date(elem.bdate).toLocaleDateString()) && 
        ((parseInt(startTimeInString) >= parseInt(start)) &&
        (parseInt(endTimeInString) <= parseInt(end)))}
        )
        return dateError > -1 ? true: false
      })

      if(error){
        this.setState({
          calendarErrorMessage: "The slot is already booked for the selected date!",
        });
        return false;
      }
    }
    if (this.state.selectedEndtime < this.state.selectedtime) {
      this.setState({
        calendarErrorMessage: "End time value cannot be before start time!",
      });
      return false;
    }
    if (this.state.selectedEndtime === this.state.selectedtime) {
      this.setState({
        calendarErrorMessage: "Start time and end time cannot be same!",
      });
      return false;
    }

    // Checking for selected time comes under doctors unavailable time.
    if (this.state.doctorBookedDateTime.length > 0) {
      let sameSlot;
      let selectedstartdatetime;
      let selectedenddatetime;
      const slotdate = this.state.selectedDays.find((selectedDay) => {
        
        selectedstartdatetime = getFormattedBookedTime(selectedDay, selectedTime);
        selectedenddatetime = getFormattedBookedTime(selectedDay, selectedEndTime);
        sameSlot = this.state.doctorBookedDateTime.find((element)=> {
              const bookedStartDateTime = getFormattedBookedTime(element.bdate, element.start);
              const bookedEndDateTime = getFormattedBookedTime(element.bdate, element.end);
              return !!((selectedstartdatetime > bookedStartDateTime && selectedstartdatetime < bookedEndDateTime)||
              (selectedenddatetime > bookedStartDateTime && selectedstartdatetime < bookedEndDateTime));
              } )
        if(sameSlot){
          return true
        }
    
      })
           
      if(sameSlot){
        this.setState({
          calendarErrorMessage:
            "Requested Professional is not available at selected date and time.",
        });
        return true;
      }
    }

    // if (this.state.doctorBookedDateTime.length === 0) {
    //   this.setState({
    //     calendarErrorMessage:
    //       "Requested professional has not blocked date and time for selected room.",
    //   });
    //   return true;
    // }

    // if (this.state.selectedEndtime === this.state.selectedtime) {
    //   this.setState({
    //     calendarErrorMessage:
    //       "Please select date and time as specified in blocked date and time displayed above.",
    //   });
    //   return true;
    // }
    const selectedData = [...this.state.selectedDays];

    const data = selectedData.map((day) => {
      return {
        bdate: day.toISOString(),
        start: this.state.selectedtime,
        end: selectedEndTime,
      };
    });
    selectedDateTime.push(...data);
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
      selectedDateTime,
      selectedDays: [],
    }));

    if (this.state.isEditMode === true) {
      this.setState({ isReschedule: true });
    }
    // Check date greater than today
   this.reminderSet(selectedTime);
  };

  reminderSet = (selectedTime) =>{
    let today = new Date();

    let selectedDateIsToday = this.state.selectedDateTime.find((date)=>(
      moment(today).format("YYYY-MM-DD") === moment(date.bdate).format("YYYY-MM-DD")
    ));

    let dateArr = [
      { id: 1, label: "1 hour before" },
      { id: 2, label: "2 hours before" },
      { id: 3, label: "3 hours before" },
      { id: 4, label: "4 hours before" },
    ];

    if(selectedDateIsToday && this.state.selectedDateTime.length === 1){

    //let selectedDateOnly = this.state.selectedDays[0];

    let currentTime = today.getHours();
    let selectedStartTime;
    if(selectedTime){
      selectedStartTime = selectedTime
    }else{
      selectedStartTime = this.state.selectedDateTime[0].start;
    }
    let selectedTimeHours = parseInt(selectedStartTime.split(":")[0]);
   // let newToady = moment(today).format("YYYY-MM-DD");
   // let newSelectedDateOnly = moment(selectedDateIsToday).format("YYYY-MM-DD");
    // if (
    //   newSelectedDateOnly == newToady &&
    //   this.state.selectedDays.length == 1
    // ) {
      if (parseInt(currentTime) == selectedTimeHours) {
        dateArr.splice(dateArr.length - 4);
      } else if (parseInt(currentTime + 1) == selectedTimeHours) {
        dateArr.splice(dateArr.length - 4);
      } else if (parseInt(currentTime + 2) == selectedTimeHours) {
        dateArr.splice(dateArr.length - 3);
      } else if (parseInt(currentTime + 3) == selectedTimeHours) {
        dateArr.splice(dateArr.length - 2);
      } else if (parseInt(currentTime + 4) == selectedTimeHours) {
        dateArr.splice(dateArr.length - 1);
      } else if (parseInt(currentTime + 5) == selectedTimeHours) {
        dateArr.splice(dateArr.length - 0);
      } else if (parseInt(currentTime + 5) > selectedTimeHours) {
        this.setState({
          setRemindOneDay: "",
        });
      }
      this.setState({
        setRemindOneDay: dateArr,
      });
    //} 
    // else {
    //   dateArr.push({ id: 5, label: "1 day before" });
    //   this.setState({
    //     setRemindOneDay: dateArr,
    //   });
    // }
  }else{
    dateArr.push({ id: 5, label: "1 day before" });
    this.setState({
      setRemindOneDay: dateArr,
    });
  }
  }

  removeSelectedDate = (index) => {
    const selectedDateTime = [...this.state.selectedDateTime];
    if (selectedDateTime.length > 0) {
      selectedDateTime.splice(index, 1);
      this.setState({
        selectedDateTime,
        isReschedule: this.state.isEditMode ? true : false,
      },()=>{
        this.reminderSet();
      });
    }
  };

  renderScheduledTime(dateValue, timeValue) {
    const datetime = new Date(dateValue);
    datetime.setHours(timeValue.split(":")[0]);
    datetime.setMinutes(datetime.getMinutes() + timeValue.split(":")[1]);
    return datetime.toLocaleTimeString();
  }

  renderScheduledDates() {
    if (this.state.selectedDateTime.length > 0) {
      return (
        <div className="">
          <p>Here is the selected date(s) and time slot(s)</p>
          {this.state.selectedDateTime.map((date, index) => (
            <div key={index} className={style.inlineDateTimeInnerWrapper}>
              <span key={index} className={style.dateInfo}>
                {/* {new Date(date.bdate).toLocaleDateString()}{" "} */}
                {moment(date.bdate).format("YYYY-MM-DD")}{" "}
                {this.renderScheduledTime(date.bdate, date.start)} {" - "}
                {this.renderScheduledTime(date.bdate, date.end)}
              </span>
              {!this.state.isAppointmentConducted && (
                <i
                  className={`fa fa-times ${style.faRemove}`}
                  aria-hidden="true"
                  onClick={() => this.removeSelectedDate(index)}
                ></i>
              )}
            </div>
          ))}
        </div>
      );
    }
  }

  renderBookedDates() {
    if (this.state.doctorBookedDateTime.length > 0) {
      return (
        <div className="mt-2">
          {this.state.reqProfessional && this.state.room && this.state.doctorBookedDateTime.length > 0  && (
                        <p className="semiBold">
                          Dr.{" "}
                          {this.state.isEditMode
                            ? this.state.doctorNameLabel
                            : this.state.doctorName}{" "}is unavailable on the below date(s) and time slot(s).
                        </p>
                      )}
          {/* <p className="semiBold">
            Here is the available date(s) and time slot(s)
          </p> */}
          {this.state.doctorBookedDateTime.map((date, index) => (
            <div key={index} className={style.inlineDateTimeInnerWrapper}>
              <span key={index} className={style.dateInfo}>
                {/* {new Date(date.bdate).toLocaleDateString()}{" "} */}
                {moment(date.bdate).format("YYYY-MM-DD")}{" "}
                {this.renderScheduledTime(date.bdate, date.start)} {" - "}
                {this.renderScheduledTime(date.bdate, date.end)}
                {/* {date} */}
              </span>
              {/* <i
                className={`fa fa-times ${style.faRemove}`}
                aria-hidden="true"
                onClick={() => this.removeSelectedDate(index)}
              ></i> */}
            </div>
          ))}
        </div>
      );
    }
  }

  // Reseting form input fields
  resetForm = () => {
    this.setState({
      selectedDateTime: [],
      room: "",
      reqProfessional: "",
      selectedTime: "",
      isEditMode: false,
    });
    // this.form.reset();
  };

  // Input blur change
  handleBlurChange = () => {
    if (((this.state.user_type === "existing"  && 
    this.state.assoRelatedParty !== "") ||
    (this.state.user_type === "new"  && 
    (this.state.new_user_first_name !== "" &&
    this.state.new_user_last_name !== "" &&
    this.state.new_user_passport_number !== "" &&
    this.state.new_user_number !== "" ))) &&
      this.state.assoRelatedParty !== "" &&
      this.state.reqProfessional !== "" &&
     // this.state.authorNumber !== "" &&
      this.state.appoType !== "" &&
      this.state.room !== "" &&
      this.state.appoReason !== "" &&
      this.state.billing_policy_configuration_id !== "" &&
      this.state.rule_type_id !== "" &&
      this.state.selectedDateTime.length !== 0
    ) {
      this.setState({
        error: "",
      });
    } else if (
      this.state.isEditMode &&
      (this.state.appStatus !== null || this.state.appStatus !== "")
    ) {
      this.setState({
        error: "",
      });
    }
  };


  getValid =()=> {
    if (
      (this.state.user_type === "existing"  && 
      this.state.assoRelatedParty === "") ||
      (this.state.user_type === "new"  && 
      (this.state.new_user_first_name === ""||
      this.state.new_user_last_name === ""||
      this.state.new_user_passport_number === ""||
      this.state.new_user_number === "" )) ||
      this.state.reqProfessional === "" ||
     // this.state.authorNumber === "" ||
      this.state.appoType === "" ||
      this.state.room === "" ||
     // this.state.paymentType === "" ||
      this.state.appoReason === "" ||
      this.state.billing_policy_configuration_id === "" ||
      this.state.rule_type_id === ""
    ) {
      this.setState({
        error: "Please filled out all mandatory fields",
      });
      return false;
    } else if (this.state.selectedDateTime.length === 0) {
      this.setState({
        error: "Choose Date and Time is mandatory",
      });
      return false;
    // } else if (this.state.authorNumber && this.state.authorNumber.length !== 20) {
    //   this.setState({
    //     error: "Authorization Number must be 20 alphanumeric",
    //   });
    //   return false;
    } else if (
      this.state.isEditMode &&
      (this.state.appStatus === "" || this.state.appStatus === null)
    ) {
      this.setState({
        error: "Appointment Status is required field",
      });
      return false;
    } else {
        if(!isEmpty(this.state.showErrors)){
        this.setState({
          error: "Please filled out valid details!",
        });
        return false;
      }
    }

    return true;
  }


  // Posting all form data
  onSubmit = async () => {
    this.setState({
          isLoading: false,
          errorMessage:  ""
        });
    if (
      (this.state.user_type === "existing"  && 
      this.state.assoRelatedParty === "") ||
      (this.state.user_type === "new"  && 
      (this.state.new_user_first_name === ""||
      this.state.new_user_last_name === ""||
      this.state.new_user_passport_number === ""||
      this.state.new_user_number === "" )) ||
      this.state.reqProfessional === "" ||
      //this.state.authorNumber === "" ||
      this.state.appoType === "" ||
      this.state.room === "" ||
     // this.state.paymentType === "" ||
      this.state.appoReason === "" ||
      this.state.billing_policy_configuration_id === "" ||
      this.state.rule_type_id === ""
    ) {
      this.setState({
        error: "Please filled out all mandatory fields",
      });
    } else if (this.state.selectedDateTime.length === 0) {
      this.setState({
        error: "Choose Date and Time is mandatory",
      });
    // } else if (this.state.authorNumber && this.state.authorNumber.length !== 20) {
    //   this.setState({
    //     error: "Authorization Number must be 20 alphanumeric",
    //   });
    } else if (
      this.state.isEditMode &&
      (this.state.appStatus === "" || this.state.appStatus === null)
    ) {
      this.setState({
        error: "Appointment Status is required field",
      });
    } else {
      if(!isEmpty(this.state.showErrors)){
      this.setState({
        error: "Please filled out valid details!",
      });
          return false;
      }
      this.setState({
        error: "",
      });
      //console.log("this.state.appoType", this.state.appoType);
      const payload = {
        authorization_number: this.state.authorNumber? this.state.authorNumber: "",
        requested_related_party_id: parseInt(this.state.reqProfessional),
        lk_appointment_type: this.state.appoType,
        room_id: parseInt(this.state.room),
        lk_appointment_reason_id: parseInt(this.state.appoReason),
        billing_policy_configuration_id: Number(this.state.billing_policy_configuration_id),
        billing_policy_value: this.state.billing_policy_value ? Number(this.state.billing_policy_value) : 0,
        rule_type_id: Number(this.state.rule_type_id),
        lk_appointment_status_id: parseInt(this.state.appStatus),
        lk_reminder_id: parseInt(this.state.setRemind),
        appointment_date: this.state.selectedDateTime,
        notes: this.state.notes,
        payment_type: this.state.paymentType,
      };
      //For new patient
      if(this.state.user_type === "new"){
        payload.name = this.state.new_user_first_name;
        payload.surname = this.state.new_user_last_name;
        payload.passport_number = this.state.new_user_passport_number;
        payload.number = this.state.new_user_number;
        payload.newPatient = 1;
      }else {
        //For existing patient
        payload.associated_related_party_id = parseInt(this.state.assoRelatedParty);
      }
     // console.log("Payload", payload);

      if (this.state.isEditMode) {
        payload.appointment_id = parseInt(this.props.match.params.id);
        payload.reference_id = parseInt(this.state.reference_id);
        payload.isReschedule = this.state.isReschedule;
      }
     // console.log("Payload - ", payload);

      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };

      try {
        if (this.state.isEditMode) {
          const response = await api.put("appointment", payload, {
            headers: headers,
          });

          if (response.status === 200) {
           // console.log("Create appoinment response - ", response);
            this.setState({
              isLoading: false,
              successMessage: "Appointment updated successfully! Please wait while redirecting...",
            });
          }
          setTimeout(() => {
            this.setState({
              successMessage: "",
            });
            this.resetForm();
            history.push("/appoinmentlist");
          }, 2000);
        } else {
          const response = await api.post("appointment", payload, {
            headers: headers,
          });

          if (response.status === 200) {
           // console.log("Create appoinment response - ", response);
            this.setState({
              isLoading: false,
              successMessage: "Appointment created successfully! Please wait while redirecting...",
            });
          }
          setTimeout(() => {
            this.setState({
              successMessage: "",
            });
            // this.resetForm();
            history.push("/appoinmentlist");
          }, 2000);
        }
      } catch (error) {
        console.log("Error in create appointment", error);
        this.setState({
          isLoading: false,
          errorMessage:  error.response.data &&
          error.response.data.message ? error.response.data.message :"Something went wrong! Please try again later",
        });
      }
    }
  };

  disableCalendar = () => {
    let date = new Date();
    let month = date.getMonth();
    date.setDate(1);
    let all_days = [];
    while (date.getMonth() === month) {
      let d =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        date.getDate().toString().padStart(2, "0");
      const dataEle = this.state.doctorBookedDateTime.findIndex((element) => {
        return new Date(element.bdate).getDate() === new Date(d).getDate();
      });
     // console.log("dataEle", dataEle);
      if (dataEle === -1) {
        all_days.push(new Date(d));
      }
      date.setDate(date.getDate() + 1);
    }
    return all_days;
  };

  gotoConductAppo = () => {
    let isValid = this.getValid();
    if(!isValid){
      return false;
    }
    const payload = {
      appointment_id: parseInt(this.props.match.params.id),
      reference_id: parseInt(this.state.reference_id),
      authorization_number: this.state.authorNumber?this.state.authorNumber:"",
      associated_related_party_id: parseInt(this.state.assoRelatedParty),
      requested_related_party_id: parseInt(this.state.reqProfessional),
      lk_appointment_type: this.state.appoType,
      room_id: parseInt(this.state.room),
      lk_appointment_reason_id: parseInt(this.state.appoReason),
      billing_policy_configuration_id: Number(this.state.billing_policy_configuration_id),
      billing_policy_value: this.state.billing_policy_value ? Number(this.state.billing_policy_value) : 0,
      rule_type_id: Number(this.state.rule_type_id),
      lk_appointment_status_id: parseInt(this.state.appStatus),
      lk_reminder_id: parseInt(this.state.setRemind),
      appointment_date: this.state.selectedDateTime,
      notes: this.state.notes,
    };
    const relatedPartyDetails = {
      name: this.state.name,
      PhysicalAddress: this.state.PhysicalAddress,
      refnumber: this.state.refnumber,
      fileNumber: this.state.fileNumber,
      phoneNumber: this.state.phoneNumber,
      passport_number: this.state.passport_number,
      emailId: this.state.emailId,
      notes: this.state.notes,
    };

    // console.log(
    //   " this.state.appointmentReasonLabel",
    //   this.state.appointmentReasonLabel
    // );
    const dropdwnData = this.props.appointmentDropdownData && 
    this.props.appointmentDropdownData.appointmentDropdown ;
    const requestedProfessionalOptions = [];
    dropdwnData &&
    dropdwnData.requestedProfessional.forEach(element => {
      requestedProfessionalOptions.push({
        practitioner_id: element.related_party_id,
        practitioner_name: element.name
      });
    });



    this.props.history.push({
      pathname: `/app/conductappoinment/${this.props.match.params.id}`,
      state: {
        appointmentDetail: payload,
        appointmentReasonLabel: this.state.appointmentReasonLabel,
        relatedPartyDetails: relatedPartyDetails,
        isPatientFile: this.state.isPatientFile,
        practitionerOptions: requestedProfessionalOptions
      },
    });
  };

   isDayDisabled=(day)=>{
    //  const index= this.state.doctorBookedDateTime.findIndex(disabledDay => 
    //   DateUtils.isSameDay(day, new Date(disabledDay.bdate))
    //  )
    // if(index ==-1){
    //   return true
    // }
    const index= this.state.selectedDateTime.findIndex(disabledDay => 
      DateUtils.isSameDay(day, new Date(disabledDay.bdate))
     )
    return (DateUtils.isDayBefore(day, new Date()) || index > -1);
     
  }

  redirectToInvoice = () => {
    this.props.history.push({
      pathname: "/app/invoicedetails/" + this.state.invoice_id
    } )
  }

  viewClaimDetails = () => {
    this.props.history.push({
      pathname: "/app/claimdetails/" + this.state.mediswitch_transaction_id
    } )
  }

  redirectToEditPatient = () =>{
    this.props.history.push({
      pathname: "/app/editpatient/" + this.state.assoRelatedParty
    } )

  }

  onInvoiceDelete = async () => {
    console.log("delete")
    this.setState({
      isLoading: true,
      errorMessage:  ""

    })
    const payload={invoice_id:this.state.invoice_id}
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };

    try {

        const response = await api.delete("payment/invoice/delete", {
          headers: headers,
          data: payload
        });

        if (response.status === 200) {
          this.setState({
            isLoading: false,
            successMessage: "Invoice delete successfully",
          });

          setTimeout(() => {
            this.setState({
              isLoading:false,
              successMessage: "",
            });
            this.resetForm();
            history.push("/appoinmentlist");
          }, 2000);
        } 
        
   } catch(error){
     console.log(error.response.data.message)
    this.setState({
      isLoading: false,
      errorMessage:  error.response.data && error.response.data.message ? error.response.data.message :"Something went wrong! Please try again later"
    });
    
    // setTimeout(() => {
    //   this.setState({
    //     errorMessage: "",
    //   });
    // }, 3000);
   }
  }
  // Go to create invoice page with appointment id, Contact and doctor info
  onInvoiceSubmit = () => {
    const dropdwnData = this.props.appointmentDropdownData && 
    this.props.appointmentDropdownData.appointmentDropdown ;
    const relatedPartyDetails = dropdwnData && dropdwnData.associatedRelatedParty.find(
      (element, index) => {
        return element.related_party_id === this.state.assoRelatedParty;
      }
    );

    const reqProfessionalDetails = dropdwnData && dropdwnData.requestedProfessional.find(
      (element, index) => {
        return element.related_party_id === this.state.reqProfessional;
      }
    );

    if(checkIfPermitted(Permissions.CAPTURE_INVOICE)){
      if(isValEmpty(this.state.invoice_id)){
        this.props.history.push({
        pathname: "/app/createinvoice",
        state: {
          isManageAppointment: true,
          appoinment_id: this.props.match.params.id,
          conductappointment_id: this.state.conductappointment_id,
          related_party: relatedPartyDetails,
          requsted_professional: reqProfessionalDetails,
          address: this.state.PhysicalAddress,
          authorization_number: this.state.authorNumber,
        },
    });
  }else{
    
    this.props.history.push({
      pathname: "/app/createinvoice/"+this.state.invoice_id,
  });
  }
  }
  };

  editEstimate = () => {
    const dropdwnData = this.props.appointmentDropdownData && 
    this.props.appointmentDropdownData.appointmentDropdown ;
    const relatedPartyDetails = dropdwnData && dropdwnData.associatedRelatedParty.find(
      (element, index) => {
        return element.related_party_id === this.state.assoRelatedParty;
      }
    );

    const reqProfessionalDetails = dropdwnData && dropdwnData.requestedProfessional.find(
      (element, index) => {
        return element.related_party_id === this.state.reqProfessional;
      }
    );
    if(this.state.estimate_invoice_id){
      this.props.history.push({
        pathname: "/app/createestimate/" + this.state.estimate_invoice_id,
      });
    }else{
      this.props.history.push({
        pathname: "/app/createestimate",
        state: {
          isManageAppointment: true,
          appoinment_id: this.props.match.params.id,
          related_party: relatedPartyDetails,
          requsted_professional: reqProfessionalDetails,
          address: this.state.PhysicalAddress,
          authorization_number: this.state.authorNumber,
          isEstimate: 1
        },
      });

    }
  }

  onSubmitCashBilling = () => {
    const dropdwnData = this.props.appointmentDropdownData && 
    this.props.appointmentDropdownData.appointmentDropdown ;
    const relatedPartyDetails = dropdwnData && dropdwnData.associatedRelatedParty.find(
      (element, index) => {
        return element.related_party_id === this.state.assoRelatedParty;
      }
    );

    const reqProfessionalDetails = dropdwnData && dropdwnData.requestedProfessional.find(
      (element, index) => {
        return element.related_party_id === this.state.reqProfessional;
      }
    );

    this.props.history.push({
      pathname: "/app/receivepayment",
      state: {
        isManageAppointment: true,
        appoinment_id: this.props.match.params.id,
        conductappointment_id: this.state.conductappointment_id,
        related_party: relatedPartyDetails,
        requsted_professional: reqProfessionalDetails,
        address: this.state.PhysicalAddress,
        invoice_id: null,
        paymentType: this.state.paymentType,
        appointment_reason: this.state.appointmentReasonLabel,
        is_appointment_conducted: this.state.isAppointmentConducted,
      },
    });
  };

  // Downloading attached documents api

  downloadFile = async (appointment_id, lk_document_type_id, conductappointment_notes_id) => {
    let notesType =
      lk_document_type_id === 1
        ? "Doctor Note"
        : lk_document_type_id === 2
        ? "Referral Note"
        : "Prescription";
    this.setState({
      isLoading: true,
    });
    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    const payload = {
      appointment_id: appointment_id,
      lk_document_type_id: lk_document_type_id,
      conductappointment_notes_id: conductappointment_notes_id
    };

    try {
      const response = await api.post("appointment/notes/download", payload, {
        headers: headers,
        responseType: "blob",
      });

      if (response.status === 200) {
        this.setState({
          isLoading: false,
          successMessage: "Attached document download successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${notesType}.pdf`);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download", error);
      this.setState({
        isLoading: false,
        errorMessage: "Error in download",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };

  handleOptionChange = (event) => {
    this.setState({
      user_type: event.target.value,
    });
  };

  // Download patient file
  onDownloadSubmitFile = async () => {
    this.setState({
      isCaseFileDownloading: true,
    });

    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    const payload = {
      patient_id: this.state.assoRelatedParty,
    };

    try {
      const response = await api.post(
        "appointment/patientfile/download",
        payload,
        {
          headers: headers,
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        this.setState({
          isCaseFileDownloading: false,
          successMsg: "Patient file download successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        if(this.state.fileNumber){
          link.setAttribute("download", `${this.state.fileNumber}.pdf`);
        }else{
          link.setAttribute("download", `${this.state.name}.pdf`);
        }
        
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMsg: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download", error);
      this.setState({
        isCaseFileDownloading: false,
        errorMsg: "Error in download",
      });
      setTimeout(() => {
        this.setState({
          errorMsg: "",
        });
      }, 2000);
    }
  };

  handleSelectDate = (value) => {
    // console.log("doctoe", this.state.doctorBookedDateTime) ;
    // console.log("selectedDtate", this.state.selectedDateTime) ;
    // console.log("seelcted", value);
    let selections = value.map((item)=> JSON.parse(item));
   // console.log("selections",selections)
    this.setState({
      selectedDateTime: selections,
      isReschedule: this.state.isEditMode ? true : false,
    },()=>{
      this.setRemindTime();
    })
  }

  static getDerivedStateFromProps(nextProps, prevState) {
   // console.log("nextProps", nextProps);
    return nextProps;
  }

  render() {
    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
    // Getting initial dropdown data
    // const {
    //   associatedRelatedParty,
    //   requestedProfessional,
    //   appointmentReason,
    //   roomOptions,
    //   appointmentStatus,
    // } = this.state;
    const dropdwnData = this.props.appointmentDropdownData && 
    this.props.appointmentDropdownData.appointmentDropdown ;
    
    const billingPolicy = dropdwnData && dropdwnData.billingPolicyConfiguration;
    const billingPolicyOptions = billingPolicy &&
      billingPolicy.map((element, index) => (
        <option key={index} value={element.billing_policy_configuration_id}>
          {element.billing_policy}
        </option>
      ));
      const ruleTypeList = this.props.dropdownListData.dropdownList &&
      this.props.dropdownListData.dropdownList.lk_rule_type;
      
     // console.log("dropdwnData", this.props.appointmentDropdownData);
    // Getting requested professional dropdown data
    // const requestedProfessionalOptions = dropdwnData &&
    // dropdwnData.requestedProfessional &&
    // dropdwnData.requestedProfessional.map((element, index) => (
    //     <option key={index} value={element.related_party_id}>
    //       {element.name}
    //     </option>
    //   ));
     // console.log("requestedProfessionalOptions", requestedProfessionalOptions);
    //  console.log("requestedProfessional", dropdwnData.requestedProfessional);
    // Getting appointment reason dropdown data
    const appointmentReasonOptions = dropdwnData &&
    dropdwnData.appointmentReason &&
    dropdwnData.appointmentReason.map((element, index) => (
        <option key={index} value={element.lk_appointment_reason_id}>
          {element.appointment_reason}
        </option>
      ));

    // Getting room dropdown data
    const roomOptionsData =dropdwnData && 
    dropdwnData.room &&
    dropdwnData.room.map((element, index) => (
        <option key={index} value={element.room_id}>
          {element.room_name}
        </option>
      ));

    // Getting appoinment status dropdwon data
    const appStatusData = dropdwnData &&
    dropdwnData.appointmentStatus &&
    dropdwnData.appointmentStatus.map((element, index) => (
        <option key={index} value={element.lk_appointment_status_id}>
          {element.appointment_status}
        </option>
      ));


    // getting set remind only

    const remindOptions =
      this.state.setRemindOneDay &&
      this.state.setRemindOneDay.map((element, index) => (
        <option key={index} value={element.id}>
          {element.label}
        </option>
      ));


      // const dateSelections = this.state.selectedDateTime && 
      // this.state.selectedDateTime.length > 0 ?
      // this.state.selectedDateTime.map((item)=> JSON.stringify(item)):[];


    return (
      <div>
          <div className={style.appoCreationMainWrapper}>
            <div className="row">
              <div className="col-lg-12">
                {/* <h3>Appointment Creation</h3> */}
                <h3>{this.state.isPageTitle}</h3>
              </div>
              {!this.props.match.params.id ? (
                <div className="col-lg-12 intro-text">
                  <p className="mb-1">
                  Schedule an Appointment by completing the form below. 
                  The available date, time and room will be determined by the selected Professional/Doctor. 
                  A reminder of the Appointment will be sent to the Patient as per the reminder option selected.
                  </p>
                </div>
              ) : (
                <div className="col-lg-12 intro-text">
                  <p className="mb-4">
                    Here you can manage appointments. The patient's details are
                    shown in a separate section. The status can be updated for
                    each of the appointment. Other details of the appointment
                    can be changed as needed. For recurring appointments,
                    appointment confirmation status will be applicable for all
                    the scheduled dates and time slots.
                  </p>
                </div>
              )}
            </div>
            <form
              ref={(form) => (this.form = form)}
              className={style.appFormWrapper}
            >
              <div className={style.appoDetalisWrapper}>
                <div className="row">
                  <div className="col-md-6">
                    <h4>Appointment Details</h4>
                  </div>
                  <div className="col-md-6"></div>
                </div>
                  {!this.state.isEditMode && (<div className="row mb-3">
                    <div className="col-lg-12">
                      <label className="mb-2 mr-3">Choose Patient Type :</label>
                      
                      <div className="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="existing_user"
                            name="user_type"
                            value="existing"
                            checked={this.state.user_type === "existing"}
                            onChange={this.handleOptionChange}
                          />
                          <label className="custom-control-label" htmlFor="existing_user">
                            Existing Patient
                          </label>
                        </div>
                      <div className="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="new_user"
                            name="user_type"
                            value="new"
                            checked={this.state.user_type === "new"}
                            onChange={this.handleOptionChange}
                          />
                          <label className="custom-control-label" htmlFor="new_user">
                            New Patient
                          </label>
                        </div>
                    
                    </div>
                  </div>)}

                
                 <div className="row">
                 {this.state.user_type === "new" && ( 
                   <React.Fragment>
                  <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="asso_related_party">
                        First Name{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder="First Name"
                        id="new_user_first_name"
                        name="new_user_first_name"
                        maxLength="50"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.new_user_first_name}
                        className={`form-control ${this.state.showErrors &&
                          this.state.showErrors.new_user_first_name
                            ? "is-invalid"
                            : ""
                        }`}
                      />
                      {this.state.showErrors && 
                      this.state.showErrors.new_user_first_name !== "" && (
                        <p>
                          <span className="error">
                            {this.state.showErrors.new_user_first_name}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="asso_related_party">
                        Last Name{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder="Last Name"
                        id="new_user_last_name"
                        name="new_user_last_name"
                        maxLength="50"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.new_user_last_name}
                        className={`form-control ${this.state.showErrors &&
                          this.state.showErrors.new_user_last_name
                            ? "is-invalid"
                            : ""
                        }`}
                      />
                      {this.state.showErrors && 
                      this.state.showErrors.new_user_last_name !== "" && (
                        <p>
                          <span className="error">
                            {this.state.showErrors.new_user_last_name}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="req_professional">
                      ID/Passport Number{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <input
                        type="text"
                        id="new_user_passport_number"
                        placeholder="ID/Passport Number"
                        name="new_user_passport_number"
                        maxLength="20"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.new_user_passport_number}
                      className={`form-control ${this.state.showErrors &&
                        this.state.showErrors.new_user_passport_number
                          ? "is-invalid"
                          : ""
                      }`}
                    />
                    {this.state.showErrors && 
                    this.state.showErrors.new_user_passport_number !== "" && (
                      <p>
                        <span className="error">
                          {this.state.showErrors.new_user_passport_number}
                        </span>
                      </p>
                    )}
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="auth_number">
                        Cell Phone Number{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <input
                        type="text"
                        placeholder="Cell Phone Number"
                        id="new_user_number"
                        name="new_user_number"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.new_user_number}
                        maxLength="10"
                        className={`form-control ${this.state.showErrors &&
                          this.state.showErrors.new_user_number
                            ? "is-invalid"
                            : ""
                        }`}
                      />
                      {this.state.showErrors && 
                      this.state.showErrors.new_user_number !== "" && (
                        <p>
                          <span className="error">
                            {this.state.showErrors.new_user_number}
                          </span>
                        </p>
                      )}
                    </div>
                  </div>
                  </React.Fragment>
                  )}
                  {this.state.user_type === "existing" && (
                  <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="asso_related_party">
                        Associated Patient{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      {/* <select
                        className="form-control"
                        id="asso_related_party"
                        name="assoRelatedParty"
                        onChange={this.handleInputSelChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.assoRelatedParty}
                        disabled={this.state.isAppointmentConducted || this.state.isEditMode}
                      >
                        <option value="">Select Contact</option>
                        {assoRelatedPartyOptions}
                      </select> */}
                      
                      <Select
                        showSearch
                        allowClear={true}
                        name="assoRelatedParty"
                        placeholder="Search Patient"
                        optionFilterProp="children"
                        disabled={this.state.isAppointmentConducted || this.state.isEditMode}
                        onChange={(value, event) => this.handleInputSelChange(value, "assoRelatedParty")}
                        onBlur={this.handleBlurChange}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        value={this.state.assoRelatedParty || undefined}
                      >
                        {dropdwnData && dropdwnData.associatedRelatedParty && 
                        dropdwnData.associatedRelatedParty.map((element, index) => (
                            <Option key={index} value={element.related_party_id}>
                              {element.name}
                            </Option>
                          ))}
                      </Select>
                    </div>
                  </div>)}
                  <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="reqProfessional">
                        Requested Professional/Doctor{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      {/* <select
                        className="form-control"
                        id="req_professional"
                        name="reqProfessional"
                        onChange={this.handleInputSelChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.reqProfessional}
                        disabled={this.state.isAppointmentConducted}
                      >
                        <option value="">Select Professional/Doctor</option>
                        {requestedProfessionalOptions}
                      </select> */}
                      <Select
                        showSearch
                        allowClear={true}
                        name="reqProfessional"
                        disabled={this.state.isAppointmentConducted}
                        placeholder="Search Professional/Doctor"
                        optionFilterProp="children"
                        onChange={(value, event) => this.handleInputSelChange(value, "reqProfessional")}
                        onBlur={this.handleBlurChange}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        value={this.state.reqProfessional || undefined}
                      >
                        {dropdwnData &&  dropdwnData.requestedProfessional &&
                         dropdwnData.requestedProfessional.map((element, index) => (
                            <Option key={index} value={element.related_party_id}>
                              {element.name}
                            </Option>
                          ))}
                      </Select>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="auth_number">
                        Authorization Number{" "}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="auth_number"
                        name="authorNumber"
                        placeholder="Authorization Number"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.authorNumber}
                        // disabled={this.state.isAppointmentConducted}
                        maxLength="20"
                        minLength=""
                      />
                    </div>
                  </div>
                </div>
                {this.state.isEditMode && (
                  <div className="row">
                    <div className="col-md-12">
                      <h6>Contact Details :</h6>
                      <div className={style.rPartyDetailsWrapper}>
                        <div className="row">
                          {this.state.isProfileCompleted === 0 && (
                          <div className="col-md-12 mb-2">
                              <div className="d-flex flex-md-row flex-column align-items-md-center align-items-start">
                              <span className={["mb-2",style.caseFileerrorMessage]} >
                              <i class="fa fa-warning warn-error"></i>
                                      Patient Profile is Incomplete.
                            </span>
                            <span className="d-flex align-items-center ml-md-auto">
                            <span>Edit Patient Profile</span>
                            {checkIfPermitted(Permissions.CREATE_PATIENTS) && (
                            <i class="ml-2 fa fa-pencil-square-o edit-profile" 
                            title="Complete Profile"
                            onClick={this.redirectToEditPatient}
                            aria-hidden="true"></i>)}
                            </span>
                              </div>
                          </div>)}
                          <div className="col-md-6">
                            <label>Name </label>: {this.state.name}
                          </div>
                          <div className="col-md-6">
                            <label>Physical Address </label>:{" "}
                            {checkValidData(this.state.PhysicalAddress)}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label>Reference Number </label>:{" "}
                            {checkValidData(this.state.refnumber)}
                          </div>
                          <div className="col-md-6">
                            <label>Phone Number </label>:{" "}
                            {checkValidData(this.state.phoneNumber)}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label>Email Id </label>:{" "}
                            {checkValidData(this.state.emailId)}
                          </div>
                          <div className="col-md-6"></div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <label>ID/Passport Number </label>:{" "}
                            {checkValidData(this.state.passport_number)}
                          </div>
                          <div className="col-md-6"></div>
                        </div>
                        {this.state.isPatientFile && (
                          <div className="row">
                            <div className="col-lg-12">
                              <p className={style.caseFileHeading}>Case File:</p>
                              <span
                                class={style.caseFileWrapper}
                                onClick={this.onDownloadSubmitFile}
                              >
                                <i
                                  class={`fa fa-paperclip mr-2 ${style.caseFileIcon}`}
                                ></i>
                                {this.state.fileNumber && (
                                <span> {`${this.state.fileNumber}.pdf`} </span>
                                )}
                                {!this.state.fileNumber &&(
                                <span> {`${this.state.name}.pdf`} </span>
                                )}
                                {/* {this.state.isCaseFileDownloading && (
                                <span
                                  className={`ml-2 ${style.loadingCaseFileWrapper}`}
                                >
                                  <img
                                    src={ttmLoader}
                                    className={style.loading}
                                  />
                                </span>
                              )} */}
                              </span>
                            </div>
                            
                            <div className="col-lg-12">
                            {this.state.isCaseFileDownloading ? (
                                  <span
                                    className={`ml-2 ${style.loadingCaseFileWrapper}`}
                                  >
                                    <img
                                      src={ttmLoader} alt="loader"
                                      className={style.loading}
                                    />
                                  </span>
                                ) : (
                                  <span>
                                    {this.state.successMsg && (
                                      <span
                                        className={style.caseFilesuccessMessage}
                                      >
                                        {this.state.successMsg}
                                      </span>
                                    )}
                                    {this.state.errorMsg && (
                                      <span
                                        className={style.caseFileerrorMessage}
                                      >
                                        {this.state.errorMsg}
                                      </span>
                                    )}
                                  </span>
                                )}
                                </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="appo_type">
                        Appointment Type{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <select
                        className="form-control"
                        id="appo_type"
                        name="appoType"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.appoType}
                        disabled={this.state.isAppointmentConducted}
                      >
                        <option value="">Select Appoinment Type</option>
                        <option value="New">New</option>
                        <option value="Followup">Followup</option>
                        <option value="Past Appointment">Past Appointment</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="venue">
                        Room/Venue{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <select
                        className="form-control"
                        id="venue"
                        name="room"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.room}
                        //disabled={true}
                        disabled={
                          this.state.isAppointmentConducted ||
                          !this.state.reqProfessional
                        }
                      >
                        <option value="">Select Room/Venue </option>
                        {roomOptionsData}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="appoinment_reason">
                        Appointment Reason{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <select
                        className="form-control"
                        id="appoinment_reason"
                        name="appoReason"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.appoReason}
                        disabled={this.state.isAppointmentConducted}
                      >
                        <option>Select Appointment Reason</option>
                        {appointmentReasonOptions}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="billing_policy_configuration_id">
                        Billing Policy{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span></label>
                      <select
                        className="form-control"
                        id="billing_policy_configuration_id"
                        name="billing_policy_configuration_id"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.billing_policy_configuration_id}
                        // disabled={this.state.estimate_invoice_id || (!isValEmpty(this.state.invoice_id))}
                      >
                      <option value="">Select Billing Policy</option>
                      {billingPolicyOptions}
                      </select>
                    </div>
                  </div> 
                  <div className="col-md-6 col-lg-4">
                    <div className="form-group">
                      <label htmlFor="rule_type_id">
                        Rule Type{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span></label>
                      <select
                        className="form-control"
                        id="rule_type_id"
                        name="rule_type_id"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.rule_type_id}
                        disabled={this.state.isAppointmentConducted || this.state.invoice_id || this.state.estimate_invoice_id}
                      >
                      <option value="">Select Rule Type</option>
                      {ruleTypeList && ruleTypeList.map((item, index) => (
                        <option key={index} value={item.lk_rule_type_id}>{item.rule_type_label}</option>
                      ))}
                      </select>
                    </div>
                  </div> 
                </div>
                <div className="row">
                  <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="additional_notes">Additional Notes</label>
                      <textarea
                        className="form-control"
                        rows="2"
                        id="additional_notes"
                        placeholder="Write notes here..."
                        name="notes"
                        onChange={this.handleInputChange}
                        value={this.state.notes}
                        //disabled={this.state.isAppointmentConducted}
                      ></textarea>
                    </div>
                  </div>
                  {this.state.isEditMode && (
                    <div className="col-md-6 col-xl-4">
                      <div className="form-group">
                        <label htmlFor="appoinment_status">
                          Appointment Status
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <select
                          className="form-control"
                          id="appoinment_status"
                          name="appStatus"
                          disabled={this.state.conductappointment_id}
                          onChange={this.handleInputChange}
                          onBlur={this.handleBlurChange}
                          value={this.state.appStatus}
                        >
                          <option value="">Select Appointment Status</option>
                          {appStatusData}
                        </select>
                      </div>
                    </div>
                  )}
                  {/* <div className="col-md-6 col-xl-4">
                    <div className="form-group">
                      <label htmlFor="appoinment_status">
                        Payment Type
                        <span className="mandatory">
                          <small>*</small>
                        </span>
                      </label>
                      <select
                        className="form-control"
                        id="paymentType"
                        name="paymentType"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                        value={this.state.paymentType}
                        disabled={this.state.isEditMode}
                      >
                        <option value="">Select Payment Type</option>
                        <option value="1">Pre-Payment</option>
                        <option value="2">Post-Payment</option>
                      </select>
                    </div>
                  </div>*/}

                </div> 
                {!this.state.isAppointmentConducted && (
                  <div className="row">
                    <div className="col-md-12">
                      {/* {this.state.reqProfessional && this.state.room && this.state.doctorBookedDateTime.length > 0  && (
                        <p>
                          Choose your appointment date and time according to the doctor{" "}
                          {this.state.isEditMode
                            ? this.state.doctorNameLabel
                            : this.state.doctorName}'s{" "}availability.
                        </p>
                      )} */}
                    </div>
                      <div className="col-md-12">
                        {this.renderBookedDates()}
                      </div>
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="mr-3">
                          Choose Date and Time{" "}
                          <span className="mandatory">
                            <small>*</small>
                          </span>
                        </label>
                        <Button
                          className="ttm-primary-btn d-block"
                          disabled={!this.state.reqProfessional}
                          onClick={this.toggle}
                          onBlur={this.handleBlurChange}
                        >
                          <i className="fa fa-calendar mr-1"></i> Choose Date
                          and Time
                        </Button>
                        {/* <Select
                          mode="multiple"
                          style={{ width: '100%' }}
                          placeholder="Click here to select available slots"
                          onChange={this.handleSelectDate}
                          disabled={this.state.doctorBookedDateTime.length === 0}
                          value={dateSelections}
                        >
                          {this.state.doctorBookedDateTime.map((date, index) => (
                            <Option key={index} value={JSON.stringify(date)}>
                                {new Date(date.bdate).toLocaleDateString()}{" "}
                                {this.renderScheduledTime(date.bdate, date.start)} {" - "}
                                {this.renderScheduledTime(date.bdate, date.end)}</Option>
                          ))}
                        </Select> */}
                      </div>
                       {/* {(this.state.doctorBookedDateTime.length === 0 && this.state.reqProfessional && 
                      this.state.room) && (
                        <p className="slotMessage">No time slots available for the selected Practitioner.</p>
                      )}  */}
                    </div>
                  </div>
                )}
                <div className="row">
                  <div className="col-lg-12">{this.renderScheduledDates()}</div>
                </div>
              </div>

              {this.state.selectedDateTime.length > 0 &&(
              <div className={style.remindWrapper}>
                <div className="row">
                  <div className="col-md-6">
                    <h4>Set Reminder</h4>
                  </div>
                  <div className="col-md-6"></div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-lg-6 col-xl-4">
                    <div className="form-group">
                      <select
                        className="form-control"
                        id="set_remind"
                        name="setRemind"
                        onChange={this.handleInputChange}
                        value={this.state.setRemind}
                        disabled={this.state.isAppointmentConducted}
                      >
                        <option value="">Select Reminder</option>
                        {/* <option vale="1">1 hour before</option>
                        <option value="2">2 hour before </option>
                        <option value="3">3 hour before</option>
                        <option value="4">4 hour before</option> */}
                        {remindOptions}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 col-xl-8"></div>
                </div>
              </div>)}

              {checkIfPermitted(Permissions.MANAGE_LETTERS) && this.state.isEditMode && (
                <div className="form-box-shadow mt-4">
                  <div className="row">
                    <div className="col-lg-12">
                      <h4>Attached Documents</h4>
                      <AppointmentNotesSection data={this.state} />
                      {/* <ul className={style.attchmentDocList}>
                        {this.state.attachedDocuments &&
                          this.state.attachedDocuments.map((element, index) => (
                            <li kay={element.conductappointment_notes_id}>
                              <div>
                                <i
                                  className={`fa fa-paperclip mr-2 ${style.attachmentIcon}`}
                                ></i>
                                
                                <span>
                                  {element.lk_document_type_id === 1
                                    ? "Doctor Note"
                                    : element.lk_document_type_id === 2
                                    ? "Referral Note"
                                    : "Prescription"}
                                </span>
                              </div>
                              <div>
                                <i
                                  onClick={(e) =>
                                    this.downloadFile(
                                      element.appointment_id,
                                      element.lk_document_type_id,
                                      element.conductappointment_notes_id
                                    )
                                  }
                                  className={`fa fa-download ${style.downloadIcon}`}
                                  aria-hidden="true"
                                ></i>
                              </div>
                            </li>
                          ))}
                        {(!this.state.attachedDocuments ||
                          this.state.attachedDocuments.length === 0) && (
                          <li>
                            <p>No attached documents found</p>
                          </li>
                        )}
                      </ul> */}
                    </div>
                  </div>
                </div>
              )}

              {this.state.error && (
                <div className={`error ${style.errorText}`}>
                  {this.state.error}
                </div>
              )}
               {this.state.isLoading ? (
                    <div className={style.loadingWrapper}>
                      <img src={ttmLoader} alt="loader" className={style.loading} />
                    </div>
                  ) : (
                    <div>
                      {this.state.successMessage && (
                        <p className={style.successMessage}>
                          {this.state.successMessage}
                        </p>
                      )}
                      {this.state.errorMessage && (
                        <p className={style.errorMessage}>
                          {this.state.errorMessage}
                        </p>
                      )}
                    </div>
                  )}

              <div
                className={`d-flex justify-content-end flex-column-reverse flex-md-row align-items-center ${style.crateAppoBtnWrapper}`}
              >
                 {checkIfPermitted(Permissions.CAPTURE_INVOICE) && this.state.appointment_id &&  this.state.isProfileCompleted === 1 && (
                    <Button
                      className="ttm-primary-btn mb-3 mx-1"
                      type="button"
                      onClick={this.editEstimate}
                    >
                      {!this.state.estimate_invoice_id?"Create":"Edit"} Estimate{" "}
                    </Button>
                  )}
                {/* {checkIfPermitted(Permissions.RECIEVE_PAYMENT) &&
                  this.state.isEditMode &&
                  this.state.paymentType == "1" && (
                    <Button
                      className="ttm-primary-btn mb-3 mx-1"
                      type="button"
                      onClick={this.onSubmitCashBilling}
                    >
                      Receive Payment{" "}
                    </Button>
                  )} */}
                {this.props.match.params.id && (Number(this.state.intialAppStatus) === 5 || this.state.appoType=="Past Appointment" ) &&
                    !this.state.isAppointmentConducted && 
                    checkIfPermitted(Permissions.CONDUCT_APPOINTMENT) && this.state.isProfileCompleted === 1 &&(
                      <Button
                        className="ttm-primary-btn mx-1 mb-3"
                        onClick={() => {
                          this.gotoConductAppo();
                        }}
                      >
                        Conduct Appointment
                      </Button>
                    )
                }

                {Number(this.state.invoice_list_type) === 1 && this.state.mediswitch_transaction_id &&  this.state.isProfileCompleted === 1 && (
                    <Button
                      className="ttm-primary-btn mx-1 mb-3"
                      type="button"
                      onClick={this.viewClaimDetails}
                    >
                      View Claim Details
                    </Button>
                  )}
                {checkIfPermitted(Permissions.CAPTURE_INVOICE) && this.state.intialAppStatus !== "" && 
                this.state.intialAppStatus !== null && ((Number(this.state.intialAppStatus) !== 1 && 
                Number(this.state.intialAppStatus) !== 3 && Number(this.state.intialAppStatus) !== 4 )||this.state.appoType=="Past Appointment")&& 
                Number(this.state.invoice_list_type) !== 1 && this.state.isProfileCompleted === 1 &&  (
                    <Button
                      className="ttm-primary-btn mx-1 mb-3"
                      type="button"
                      onClick={this.onInvoiceSubmit}
                    >
                      {isValEmpty(this.state.invoice_id) ? "Create":"Edit"} Invoice{" "}
                    </Button>
                  )}

{checkIfPermitted(Permissions.CAPTURE_INVOICE) && this.state.intialAppStatus !== "" && 
                this.state.intialAppStatus !== null && ((Number(this.state.intialAppStatus) !== 1 && 
                Number(this.state.intialAppStatus) !== 3 && Number(this.state.intialAppStatus) !== 4 )||this.state.appoType=="Past Appointment")&& 
                Number(this.state.invoice_list_type) !== 1 && this.state.isProfileCompleted === 1 && !isValEmpty(this.state.invoice_id) && (
                    <Button
                      className="ttm-primary-btn mx-1 mb-3"
                      type="button"
                      onClick={this.onInvoiceDelete}
                    >
                      Delete Invoice{" "}
                    </Button>
                  )}

                  {checkIfPermitted(Permissions.VIEW_INVOICE) && this.state.isProfileCompleted === 1 &&
                  this.state.isAppointmentConducted && !isValEmpty(this.state.invoice_id) && (
                    <Button
                      className="ttm-primary-btn mx-1 mb-3"
                      type="button"
                      onClick={this.redirectToInvoice}
                    >
                      View Invoice{" "}
                    </Button>
                  )}

                  <Button
                    className="ttm-primary-btn mx-1 mb-3"
                    type="button"
                    onClick={this.onSubmit}
                  >
                    {this.state.isEditMode
                      ? "Update Appointment"
                      : "Create Appointment"}
                  </Button>
              </div>

              {/* <div className="row">
                <div className="col-md-12">
                 
                </div>
              </div> */}

              {/* Modal for datetime picker */}
              <div>
                <Modal
                  isOpen={this.state.isOpen}
                  toggle={this.toggle}
                  className={style.dateTimeModal}
                  centered
                >
                  <ModalHeader
                    toggle={this.toggle}
                    className={style.deleteModalHeader}
                  >
                    Choose your Appointment Date and Time :
                  </ModalHeader>
                  <ModalBody className={style.dateTimeModalBody}>
                    {this.state.doctorBookedDateTime && this.state.doctorBookedDateTime.length > 0 && 
                    (
                      <React.Fragment>
                        <div className="row">
                          <div className="col-md-12">
                            <p>
                              Below are the dates and time slots for which the
                              doctor is not available. Please schedule your appointment out
                              any of these dates and time slots.
                            </p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12">
                            {this.renderBookedDates()}
                          </div>
                        </div>
                    </React.Fragment>
                    )}

                    {this.state.showDatetime && (
                      <div className="row">
                        <div className="col-lg-6 text-center text-lg-left mb-3">
                          <label className={style.datetimeLabel}>
                            Choose Date
                          </label>
                          <DayPicker
                            initialMonth={
                              new Date(
                                new Date().getFullYear(),
                                new Date().getMonth()
                              )
                            }
                            // fromMonth={
                            //   new Date(
                            //     new Date().getFullYear(),
                            //     new Date().getMonth()
                            //   )
                            // }
                            selectedDays={this.state.selectedDays}                        
                           // disabledDays={this.isDayDisabled}
                            onDayClick={this.handleDayClick}
                          />
                        </div>
                        <div
                          className={`col-lg-6 text-center text-lg-left mb-3 ${style.timePickerWrapper}`}
                        >
                          <label className={style.datetimeLabel}>
                            Choose Time
                            <br />
                            <small>24 Hours Time format</small>
                          </label>
                          {/* <div className="row">
                            <div className="col-lg-6 mb-2">
                              <label className="mr-2 text-left">
                                Start Time
                              </label>
                            </div>
                            <div className="col-lg-6 mb-2">
                              <label className="mr-2 text-left">End Time</label>
                            </div>
                          </div> */}
                          <div className="row">
                            <div className="col-lg-6 mb-2">
                              <label className="mr-2 text-left">
                                Start Time
                              </label>
                              <TimeField
                                style={{ width: "80%", height: "10%" }}
                                value={this.state.selectedtime} // {String}   required, format '00:00' or '00:00:00'
                                onChange={this.handlerTimeChange} // {Function} required
                                // {/* input={<MyCustomInputElement />}*/}// {Element}  default: <input type="text" />
                                colon=":" // {String}   default: ":"
                                showSeconds={false} // {Boolean}  default: false
                                name={"selectedtime"}
                              />
                            </div>
                            <div className="col-lg-6 mb-2">
                              <label className="mr-2 text-left">End Time</label>
                              <TimeField
                                style={{ width: "80%", height: "10%" }}
                                value={this.state.selectedEndtime} // {String}   required, format '00:00' or '00:00:00'
                                onChange={this.handlerTimeChange} // {Function} required
                                // {/* input={<MyCustomInputElement />}*/}// {Element}  default: <input type="text" />
                                colon=":" // {String}   default: ":"
                                showSeconds={false} // {Boolean}  default: false
                                name={"selectedEndtime"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* {this.state.isEditMode && (
                      <div className={style.bookedTimeShowWrapper}>
                        <div className="row">
                          <div className="col-lg-12">
                            {this.renderUpdateBookedDates()}
                          </div>
                        </div>
                      </div>
                    )} */}
                    <div className={style.bookedTimeShowWrapper}>
                      <p className={style.errorMessage}>
                        {this.state.calendarErrorMessage}
                      </p>
                    </div>
                  </ModalBody>
                  <ModalFooter className={style.dateTimeBtnWrapper}>
                    <Button
                      onClick={this.toggle}
                      className="tmed-btn tmed-primary-btn"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={this.save}
                      className="tmed-btn tmed-primary-btn"
                    >
                      Save
                    </Button>
                  </ModalFooter>
                </Modal>
              </div>
            </form>
          </div>
        {/* )} */}
      </div>
    );
  }
}

//export default AppoinmentCreation;

const mapStateToProps = (state) => {
  return {
    appointmentDropdownData: state.appointmentDropdown,
    dropdownListData: state.dropdownList
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAppointmentDropdown: () => dispatch(fetchAppointmentDropdown()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppoinmentCreation);
